import { useQuery } from '@tanstack/react-query';

import { PromocaoRevendedor } from '../types';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryPromocao() {
    const requestListagem = useRequestListagem();
    const { page, limit, sort, filter } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/promocaorevendedor',
        sort: sort?.length ? sort : [{ property: 'idPromocaoRevendedor', direction: 'DESC' }],
        nested: true,
        page,
        limit,
        filter,
    };

    return useQuery<RequestListagem<PromocaoRevendedor[]>>([requestOptions], () => requestListagem(requestOptions).then((res) => res.data));
}
